<div class="patrol-roblox-page">
  <a class="back-link" routerLink="/setup">
    <img src="/public/svgs/arrow-left-g.svg" alt="" width="16" height="16" />
    {{ 'app.patrol.communities.backToSources' | translate }}
  </a>

  <div class="page-top">
    <div class="page-header">
      <img
        class="page-header__logo"
        src="/public/logos/roblox.svg"
        alt=""
        width="40"
        height="40"
      />
      <div>
        <h1 class="page-title">
          {{ 'app.patrol.roblox.cockpit.title' | translate }}
        </h1>
        <p class="page-subtitle">
          {{ 'app.patrol.roblox.cockpit.subtitle' | translate }}
        </p>
      </div>
    </div>
  </div>

  <app-patrol-roblox-experience-switcher />

  @if (selectedExperience(); as experience) {
    <nav class="cockpit-tabs" aria-label="Roblox cockpit sections">
      @for (tab of tabs; track tab.id) {
        <button
          type="button"
          class="cockpit-tabs__btn"
          [class.cockpit-tabs__btn--active]="activeTab() === tab.id"
          (click)="setTab(tab.id)"
        >
          {{ tab.labelKey | translate }}
        </button>
      }
    </nav>

    <div class="cockpit-panel">
      @switch (activeTab()) {
        @case ('overview') {
          <app-patrol-roblox-universe-overview [experience]="experience" />
        }
        @case ('studio') {
          <app-patrol-roblox-studio-bridge [experience]="experience" />
        }
        @case ('policies') {
          <app-patrol-roblox-policies />
        }
        @case ('queue') {
          <app-patrol-roblox-mod-queue />
        }
      }
    </div>
  }
</div>
